export default __webpack_public_path__ + "static/media/furiousstrikes.318eb68c.png";